<script lang="ts">
  import { fade, slide } from "svelte/transition";
  import { createEventDispatcher, onDestroy, onMount } from "svelte";
  import { portal } from "svelte-portal/src/Portal.svelte";
  import { clickOutside } from "$lib/utils/clickOutside";

  export let delay = 6000;
  export let isOpen = false;

  onMount(() => {
    document.addEventListener("scroll", event => {
      if (isOpen) close(event);
    });
  });

  onDestroy(() => clearTimeout(timeout));

  export let disableAutoDismiss = false;

  let timeout;

  let isSafari =
    typeof navigator !== "undefined"
      ? /^(?!.*chrome).*safari/i.test(navigator.userAgent)
      : false;

  $: transitionToUse = isSafari ? fade : slide;

  const dispatch = createEventDispatcher<{
    close: any;
    open: any;
    startTimeout: any;
    cancelTimeout: any;
  }>();

  export const startTimeout = (event: any = {}) => {
    if (!disableAutoDismiss) {
      timeout = setTimeout(function () {
        close(event);
      }, delay);
    }
  };

  export const cancelTimeout = () => {
    if (!disableAutoDismiss) {
      clearTimeout(timeout);
    }
  };

  export const open = (event: any = {}) => {
    isOpen = true;
    dispatch("open", { isOpen, ...event });
    dispatch("startTimeout", { event });
  };

  export const close = (event: any = {}) => {
    isOpen = false;
    dispatch("close", { isOpen, ...event });
    dispatch("cancelTimeout");
  };
</script>

<style lang="scss">
  .drawer {
    display: flex;
    z-index: 1003;
    position: fixed;
    top: 0;
    width: 100%;
  }

  .dialog {
    width: 100%;
    background-color: $surface;
  }

  .cover {
    background-color: $on-surface-10;
    position: fixed;
    z-index: 10;
    height: 100vh;
    width: 100vw;
    top: 0px;
  }
</style>

{#if isOpen}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <!-- svelte-ignore a11y-no-noninteractive-tabindex -->
  <div
    transition:transitionToUse={{ duration: 750 }}
    class="drawer"
    use:portal
    on:keydown
    on:click|self={close}
    on:mouseenter={cancelTimeout}
    on:mouseleave={startTimeout}
    use:clickOutside
    on:click-outside={close}
    on:introend={startTimeout}
  >
    <div
      class="dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal"
      tabindex="0"
    >
      <slot />
    </div>
  </div>
  <div use:portal transition:fade={{ duration: 750 }} class="cover" />
{/if}
